import React, { useEffect, useState } from "react";
import SelectCustom from "../../components/SelectCustom";
import axios from "axios";
import { useNavigate, createSearchParams } from "react-router-dom";
import { MenuSide } from "../../components/MenuSide";
import { Button, TextField, FormControl, Switch } from "@mui/material";
import InputCustom from "../../components/InputCustom";
import {
  urlAdicionarDisparos,
  tokenUsuario,
  urlConsultaTemplatesisparos,
  urlConsultaListasTransmissao,
} from "../../utils/constants";

export default function AdicionarDisparo() {
  const navigate = useNavigate();
  const [mensagem, setMensagem] = useState("");
  const [data, setData] = useState("");
  const [templates, setTemplates] = useState([]);
  const [template, setTemplate] = useState("");
  const [listas, setListas] = useState([]);
  const [listasEnviar, setListasEnviar] = useState([]);

  const adicionarDisparo = async () => {
    try {
      const response = await axios.post(urlAdicionarDisparos, {
        mensagem: mensagem,
        token: tokenUsuario,
        listas: listasEnviar,
        template: template,
        data:data
      });
      if (response.data) {
        navigate({
        pathname: "/disparos/detalhe",
        search: createSearchParams({
          id: response.data,
        }).toString(),
      });
      }
    } catch (error) {
      return null;
    }
  };

const listarTemplates = async () => {
  try {
    const response = await axios.post(urlConsultaTemplatesisparos, {
      token: tokenUsuario,
    });

    // filtra apenas os templates com status APPROVED
    const templatesAprovados = (response.data.data || []).filter(
      (tpl) => tpl.status === "APPROVED"
    );

    setTemplates(templatesAprovados);
  } catch (error) {
    console.error("Erro ao listar templates:", error);
    return null;
  }
};


  const listarListasTransmissao = async () => {
    try {
      const response = await axios.post(urlConsultaListasTransmissao, {
        token: tokenUsuario,
      });
      setListas(response.data);
    } catch (error) {
      return null;
    }
  };

  useEffect(() => {
      const tomorrow = new Date();
  tomorrow.setDate(tomorrow.getDate() + 1);
  tomorrow.setHours(5, 0, 0, 0);

  // formata manualmente para YYYY-MM-DDTHH:mm no fuso local
  const pad = (n) => n.toString().padStart(2, "0");
  const formatted =
    tomorrow.getFullYear() +
    "-" +
    pad(tomorrow.getMonth() + 1) +
    "-" +
    pad(tomorrow.getDate()) +
    "T" +
    pad(tomorrow.getHours()) +
    ":" +
    pad(tomorrow.getMinutes());

  setData(formatted);
    listarTemplates();
    listarListasTransmissao();
  }, []);

  // função para lidar com clique no switch
  const handleToggleLista = (id, checked) => {
    console.log(id, checked);
    if (checked) {
      // adiciona se não estiver
      setListasEnviar((prev) => [...prev, id]);
      console.log(listasEnviar)
    } else {
      console.log(listasEnviar)
      // remove se estiver
      setListasEnviar((prev) => prev.filter((itemId) => itemId !== id));
    }
  };

  return (
    <>
      <div className="row">
        <div className="col-sm-2">
          <MenuSide />
        </div>
        <div className="col-sm-10">
          <div className="card" style={{ margin: "30px" }}>
            <div className="card-header">
              <div className="row">
                <div
                  className="col-sm-3"
                  style={{ fontWeight: 700, fontSize: "25px" }}
                >
                  Adicionar mensagem
                </div>
              </div>
            </div>
            <div className="card-body">
              <div className="row">
                <div className="col-sm-6">
                  <h6>&nbsp;Template</h6>
                  <SelectCustom
                    value={template}
                    setValue={(event) => {
                      setTemplate(event.target.value);
                    }}
                    itens={templates}
                    valueItem={"name"}
                    nameItem={"name"}
                  />
                  <h6>Descrição</h6>
                  <FormControl fullWidth>
                    <TextField
                      placeholder="Descrição"
                      onChange={(event) => {
                        event.preventDefault();
                        setMensagem(event.target.value);
                      }}
                      value={mensagem}
                      type="text"
                      InputProps={{
                        sx: {
                          height: "39px",
                          borderRadius: "0.5rem",
                          width: "100%",
                          padding: "10px",
                        },
                      }}
                      variant="outlined"
                    />
                  </FormControl>
                </div>
                <div className="col-sm-6">
                  <h6>Data envio</h6>
                  <InputCustom
                    value={data}
                    setValue={(event) => {
                      event.preventDefault();
                      setData(event.target.value);
                    }}
                    type="datetime-local"
                    placeHolder="Data envio"
                  />
                </div>
              </div>
              <div className="row">
                {listas.map((item, index) => (
                  <div className="col-sm-3 mt-3" key={index}>
                    <div className="card" value={item.id}>
                      <div className="container">
                        {item.nome}
                        <Switch
                          checked={listasEnviar.includes(item.id)}
                          onChange={(e) =>
                            handleToggleLista(item.id, e.target.checked)
                          }
                        />
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            </div>
            <div className="card-footer">
              <div className="row">
                <div className="col-sm-3"></div>
                <div className="col-sm-9 text-end">
                  <Button
                    color={"error"}
                    variant={"contained"}
                    onClick={() => {
                      adicionarDisparo();
                    }}
                    style={{
                      width: 150,
                      height: 40,
                      borderRadius: "0.5rem",
                      marginTop: "4px",
                    }}
                  >
                    Confirmar
                  </Button>
                  <br />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
